<h2 mat-dialog-title style="font-weight: normal; padding: 1.5rem 1.5rem 0px 1.5rem">
	<span fxFlex>{{title}}</span>
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog()" class="primary-light-color" style="cursor: pointer"
			>close</mat-icon
		>
	</span>
</h2>
<mat-progress-bar *ngIf="isUpdating" mode="indeterminate"></mat-progress-bar>
<mat-divider></mat-divider>

<mat-dialog-content style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<ng-container [ngSwitch]="messageType">
		<div *ngSwitchCase="messageTypeEnum.FOR_AUTOMATING_BA" style="margin-top: -1rem">
			<p>
				Uploading your carriers to C4 is the first step to automating your booking process. Once you
				have carriers mapped to your account in C4 any loads you are working can be emailed to those
				carriers directly. In addition you will be able to check rates for the projects you are
				working and view analytics on how the carriers in your network are performing.
			</p>
		</div>

		<div *ngSwitchCase="messageTypeEnum.FOR_PROCURING_CARRIERS" style="margin-top: -1rem">
			<p>
				To expand your freight network and start procuring carriers and booking loads more quickly
				and efficiently upload your carriers to C4. We will map the carriers to your account, update
				their lane preferences and start tracking how strong your relationships are.
			</p>
		</div>
		<ng-container *ngIf="isExcluded;then excluded; else commonText"></ng-container>
	</ng-container>

	<div
		*ngIf="IS_NULL_OR_UNDEFINED(messageType)"
		style="
			background-color: #f5f5f5;
			border: 1px solid #ccc;
			border-radius: 2px;
			padding: 8.5px;
			font-size: 12px;
		"
	>
		<span
			>Please make sure your csv file contains business_name, mc, and dot only.(Optionally you may
			have contact_name, phone , email and hazmat).</span
		>
	</div>

	<div style="border: 1px solid #ccc; border-radius: 2px; margin-top: 1rem">
		<mat-horizontal-stepper #stepper [linear]="true" fxFlex="100">
			<mat-step>
				<ng-template matStepLabel>Upload file</ng-template>
				<app-first-step-carriers
					(clearFileEvent)="clearFile()"
					(fileUploadedEvent)="afterFileUpload($event)"
				>
				</app-first-step-carriers>
			</mat-step>

			<mat-step [completed]="fileData != null">
				<ng-template matStepLabel>Preview</ng-template>
				<app-final-step
					(resetFileData)="resetFileData()"
					(uploadFileEvent)="getSignedUrl()"
					*ngIf="fileData && fileData.length > 0"
					[errorMsgs]="errorMsgs"
					[fileData]="fileData"
				>
				</app-final-step>
			</mat-step>
		</mat-horizontal-stepper>
	</div>
</mat-dialog-content>

<ng-template #excluded>
	<p>
		You can download the excluded carrier data template
		<a class="link" href="{{S3_CSV_TEMPLATE.BULK_EXCLUDED_CARRIERS}}" target="_blank">here</a>
		or from the Excluded Carriers Templates menu any time.
	</p>

</ng-template>
<ng-template #commonText>
	<p>
		You can download the carrier data template
		<a class="link" href="{{S3_CSV_TEMPLATE.BULK_CARRIERS}}" target="_blank">here</a>
		or from the Upload Templates menu any time.
	</p>
	<p>
		All carrier relationships and analytics are private to your account and will never be shown to
		other users. You can choose to remove the data at any time.
	</p>
</ng-template>
